module.exports = __webpack_public_path__ + "static/assets/f0a1a5a5613dcef47e478e23f83478bc.jpg";